import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import setMailboxOperation from 'owa-service/lib/operation/setMailboxOperation';
export default function setMailboxForwardingConfiguration(mailboxOptions) {
    return setMailboxOperation({
        Header: getJsonRequestHeader(),
        Mailbox: mailboxOptions,
    }).then(function (responseMessage) {
        if (responseMessage.WasSuccessful) {
            return responseMessage;
        }
        else {
            throw new Error("setMailboxForwardingConfiguration " + responseMessage.ErrorCode + " " + responseMessage.ErrorMessage);
        }
    });
}
//# sourceMappingURL=setMailboxForwardingConfiguration.js.map